// Types
import { GetActionEventsResponse } from 'app/modules/actionEvents/responses';

export enum EventActionTypes {
  EDIT_EVENT = '@@events/EDIT_EVENT',
  EDIT_EVENT_SUCCESS = '@@events/EDIT_EVENT_SUCCESS',

  RETRIEVE_ACTION_EVENTS = '@@events/RETRIEVE_ACTION_EVENTS',
  RETRIEVE_ACTION_EVENTS_SUCCESS = '@@events/RETRIEVE_ACTION_EVENTS_SUCCESS',
}

export interface EventEditRequest {
  eventId: string;
  tags?: (string | number)[];
  comment?: string;
}

export interface EventState {
  actionEvents: GetActionEventsResponse;
}

export enum EvaluationLogStatus {
  PASS = 'PASS',
  FAIL = 'FAIL',
  ERROR = 'ERROR',
}

export interface EvaluationLog {
  evaluation_id: string;
  event_id: string; // external id of client
  rule_executions: {
    [rule_id: string]: {
      rule_name: string;
      status: EvaluationLogStatus;
    };
  };
}
